export default __webpack_public_path__ + "static/Enterprise-Blockchain-Development-8f87b415a18e375ebdc0d22c6c823f6e.webp";